
import { defineComponent, ref, provide, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Auth from '../boot/auth';
import Authentication from '../boot/services/Authentication';
import Area from '../boot/services/Area';
import { Area as AreaInterface, Regx, Messages } from '../types';
import { LocalStorage, openURL, SessionStorage } from 'quasar';
import Sessions from 'src/boot/services/Sessions';

export default defineComponent({
  name: 'Login',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const user = ref('');
    const password = ref('');
    const isPasswd = ref(true);
    const loading = ref(false);
    const area = ref<AreaInterface>();
    const openDialog = ref(false);
    const contactTooltip = ref(false);
    const contactFab = ref(false);
    const REGISTER_MODULE = 'cadastrar';
    const loadingIntegration = ref(false);

    provide('openDialog', openDialog);

    area.value = Area.loggedArea();

    onMounted(async () => {
      setTimeout(() => {
        contactFab.value = true;
      }, 500);
      setTimeout(() => {
        contactTooltip.value = true;
      }, 1500);
      setTimeout(() => {
        contactTooltip.value = false;
      }, 6000);

      const token = route.query.token;

      if (token) {
        await signInWithToken(token as string);
      }
    });

    const hasRegisterModule = () => {
      return area.value?.modules.includes(REGISTER_MODULE);
    };

    const showContactButton = computed(() => {
      const { label, url } = area.value?.contact || {};
      return label && url && contactFab.value;
    });

    const imageLogo = computed(() => {
      const { login_logo, logo } = area.value || {};
      return login_logo || logo || '';
    });

    const hasSession = async () => {
      const response = await Sessions.getSession({});
      return !!response?.data?._items.length;
    };

    const signIn = async () => {
      if (!area.value) return;

      loading.value = true;

      try {
        const { name } = area.value;
        const userEmail = user.value;
        const userPassword = password.value;

        await Auth.authenticateUser({
          area: name,
          email: userEmail,
          resource: 'self',
          hash: userPassword,
          platform: 'desktop',
        });

        // void questionStore.getTotalQuestions();

        const hasExistingSession = await hasSession();

        if (!hasExistingSession) {
          SessionStorage.set('session', true);
          await Sessions.saveSession();
          await router.push('/bem-vindo');
          return;
        }

        SessionStorage.set('session', true);
        void Sessions.saveSession();
        await router.push(Authentication.firstView());
      } catch (error) {
        console.error('Error during login:', error);
      } finally {
        loading.value = false;
      }
    };

    const signInWithToken = async (token: string) => {
      if (!area.value) return;
      loadingIntegration.value = true;
      loading.value = true;

      try {
        LocalStorage.clear();

        await Auth.integrationLogin(token);

        const hasExistingSession = await hasSession();

        if (!hasExistingSession) {
          SessionStorage.set('session', true);
          await Sessions.saveSession();
          await router.push('/bem-vindo');
          return;
        }

        SessionStorage.set('session', true);
        void Sessions.saveSession();
        await router.push(Authentication.firstView());
      } catch (error) {
        console.error('Error during login:', error);
      } finally {
        loading.value = false;
        loadingIntegration.value = false;
      }
    };

    const bannerColor = computed(() => {
      if (area.value?.color?.banner_skin) {
        return {
          backgroundColor: area.value.color.banner_skin,
        };
      }
      return {
        backgroundColor: '#cfcfcf',
      };
    });

    const loginColor = computed(() => {
      if (area.value?.color?.login_skin) {
        return {
          backgroundColor: area.value.color.login_skin,
        };
      }
      return {
        backgroundColor: '#cfcfcf',
      };
    });

    return {
      openDialog,
      banner: area.value.banner,
      bannerColor,
      loginColor,
      imageLogo,
      user,
      password,
      isPasswd,
      loading,
      regEmail: Regx.email,
      area,
      Messages,
      contactTooltip,
      showContactButton,
      contactFab,
      loadingIntegration,
      year: new Date().getFullYear(),
      hasRegisterModule,
      signIn,
      openURL,
    };
  },
});
